import React, { useState } from 'react';
import { Card } from '@sections/registry/components';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

export const CurationCard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('registry');
  const curationCard = t('shopSection.curationCard');
  return (
    <>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <></>
      </LazyLoadWrapper>
      <Card
        eyebrow={curationCard.eyebrow}
        eyebrowVariant="featureHed17"
        eyebrowColor="white"
        title={curationCard.title}
        titleVariant="calloutHed32"
        titleColor="white"
        wrapperStyles={{
          background: `url(${
            isVisible
              ? cloudAssetUrl('registry-q12024/gifts-you-want/bkg-curations@2x.jpg', {
                  optimization: 'default',
                })
              : ''
          }) 0% / cover no-repeat, linear-gradient(0deg, rgba(0, 0, 0, 0.56) 0%, rgba(0, 0, 0, 0.50) 63.73%, rgba(0, 0, 0, 0.00) 100%), lightgray 50%`,
          backgroundPositionY: 'top',
        }}
      />
    </>
  );
};
